import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

/**
 * Access-denied landing page. AuthGuard redirects here when the RAC
 * permission (or legacy role) check fails; previously the '/unauthorized'
 * route didn't exist and denials fell into the wildcard redirect loop.
 */
@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="content-info">
      <div class="text-center py-5">
        <i class="bi bi-shield-lock" style="font-size: 3rem;"></i>
        <h3 class="mt-3">Access denied</h3>
        <p class="text-muted">
          You don't have permission to view this page. If you believe this is
          a mistake, contact your administrator.
        </p>
        <a routerLink="/side-menu" class="btn btnprimary mt-2">Go back</a>
      </div>
    </div>
  `,
})
export class UnauthorizedComponent {}
